import React, { useCallback } from 'react';
import OutlinedRight from 'acud-icon/lib/icons/OutlinedRight';
import OutlinedLeft from 'acud-icon/lib/icons/OutlinedLeft';
;
const CarouselSwitch = ({ prefixCls, next, prev, isPrevDisabled, isNextDisabled }) => {
    const handlePrevClick = useCallback(() => {
        if (!isPrevDisabled) {
            prev();
        }
    }, [isPrevDisabled, prev]);
    const handleNextClick = useCallback(() => {
        if (!isNextDisabled) {
            next();
        }
    }, [isNextDisabled, next]);
    return (<div className={`${prefixCls}-switch`}>
            <span className={`${prefixCls}-switch-left ${isPrevDisabled ? 'disabled' : ''}`} onClick={handlePrevClick}>
                <OutlinedLeft />
            </span>
            <span className={`${prefixCls}-switch-right ${isNextDisabled ? 'disabled' : ''}`} onClick={handleNextClick}>
                <OutlinedRight />
            </span>
        </div>);
};
export default CarouselSwitch;
